
export const formatDate = (date: Date = new Date()) =>
    date.toISOString();